import { OrganizationId } from 'yeself-common/typings/application/Application';

import {
    AnalyticsActionTypes,
    FETCH_REPORT_CONFIGURATION_FAIL,
    FETCH_REPORT_CONFIGURATION_REQUEST,
    FETCH_REPORT_CONFIGURATION_SUCCESS,
    RESET_ANALYTICS_STATE,
    ReportConfiguration,
} from './types';

export const fetchReportConfigurationRequest = (
    organizationId: OrganizationId
): AnalyticsActionTypes => ({
    type: FETCH_REPORT_CONFIGURATION_REQUEST,
    payload: organizationId,
});

export const fetchReportConfigurationSuccess = (report: ReportConfiguration): AnalyticsActionTypes => ({
    type: FETCH_REPORT_CONFIGURATION_SUCCESS,
    payload: report,
});

export const fetchReportConfigurationFail = () => ({
    type: FETCH_REPORT_CONFIGURATION_FAIL,
});

export const resetAnalyticsState = () => ({
    type: RESET_ANALYTICS_STATE,
});
